module.exports = __webpack_public_path__ + "gi.svg?71cfe39b19a8cf801dac52745837879d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/gi.svg
// module id = 1374
// module chunks = 0